import Vue from 'vue';
import VueRouter from 'vue-router';
import Projects from '@/views/Projects/Projects.vue';
import Login from '@/views/Auth/Login.vue';
import ForgotPassword from '@/views/Auth/ForgotPassword.vue';
import ProjectTasks from '@/views/ProjectTasks/ProjectTasks.vue';
import RateRules from '@/views/RateRules/RateRules.vue';
import User from '@/views/User/AppUser.vue';
import EditUser from '@/views/User/EditUser.vue';
import TimeEntries from '@/views/TimeEntries/TimeEntries.vue';
import Tags from '@/views/Tags/Tags.vue';
import PublicHolidayGroup from '@/views/PublicHoliday/PublicHolidayGroup.vue';
import OwnAbsences from '@/views/Absence/OwnAbsences.vue';
import { reloadGlobalData } from '@/store/global-data-helper';
import NotFound from '@/views/NotFound.vue';
import EditCustomer from '@/views/Projects/EditCustomer.vue';
import EditProject from '@/views/Projects/EditProject.vue';
import TagEdit from '@/views/Tags/TagEdit.vue';
import ProjectTaskEdit from '@/views/ProjectTasks/ProjectTaskEdit.vue';
import ProjectReport from '@/views/Projects/ProjectReport.vue';
import TimeEntryEdit from '@/views/TimeEntries/TimeEntryEdit/TimeEntryEdit.vue';
import PauseEdit from '@/views/TimeEntries/TimeEntryEdit/PauseEdit.vue';
import OutgoingInvoiceList from '@/views/OutgoingInvoice/OutgoingInvoiceList.vue';
import OutgoingInvoiceEdit from '@/views/OutgoingInvoice/OutgoingInvoiceEdit.vue';
import List from '@/views/List/List.vue';
import OutgoingInvoiceExport from '@/views/OutgoingInvoice/OutgoingInvoiceExport.vue';
import TimeEntryExtraFieldMetadata from '@/views/TimeEntryExtraFields/TimeEntryExtraFieldMetadata.vue';
import TimeEntryExtraFieldMetadataEdit from '@/views/TimeEntryExtraFields/TimeEntryExtraFieldMetadataEdit.vue';
import StopwatchOldLayoutEdit from '@/views/Stopwatch/OldLayout/StopwatchOldLayoutEdit.vue';
import NetworkError from '@/views/NetworkError.vue';
import ListExport from '@/views/List/ListExport.vue';
import AccountSettings from '@/views/Settings/AccountSettings.vue';
import UserSettings from '@/views/Settings/UserSettings.vue';
import ListExternal from '@/views/List/ListExternal.vue';
import Logs from '@/views/Admin/Logs.vue';
import InvoiceExport from '@/views/Payment/InvoiceExport.vue';
import Register from '@/views/Auth/Register.vue';
import UserSetupError from '@/views/UserSetupError.vue';
import { UserStore } from '@/store/user-module';
import TransferAccount from '@/views/Auth/TransferAccount.vue';
import St2Migration from '@/views/Settings/St2Migration.vue';
import Test from '@/views/Test/Test.vue';
import AdvContract from '@/views/Settings/AdvContract.vue';
import OnBoardingRoute from '@/views/OnBoarding/OnBoardingRoute.vue';
import AdminQueries from '@/views/Admin/Queries.vue';
import PublicHolidayGroupEdit from '@/views/PublicHoliday/PublicHolidayGroupEdit.vue';
import PublicHolidayEdit from '@/views/PublicHoliday/PublicHolidayEdit.vue';
import PublicHolidayGroupEditSlideOut from '@/views/PublicHoliday/PublicHolidayGroupEditSlideOut.vue';
import AbsenceEdit from '@/views/Absence/AbsenceEdit.vue';
import AbsenceTeam from '@/views/Absence/AbsenceTeam.vue';
import OutInvAccountSettings from '@/views/OutgoingInvoice/Settings/OutInvAccountSettings.vue';
import TimeAccount from '@/views/TimeAccount/TimeAccount.vue';
import TimeAdjustmentEdit from '@/views/TimeAccount/TimeAdjustmentEdit.vue';
import RegenerateInvoice from '@/views/Admin/RegenerateInvoice.vue';
import UnpaidInvoices from '@/views/Admin/UnpaidInvoices.vue';
import TeamOverview from '@/views/TeamOverview/TeamOverview.vue';
import LeuteUndGeld from '@/views/Admin/LeuteUndGeld.vue';
import TeamOverviewApproval from '@/views/TeamOverview/TeamOverviewApproval.vue';
import BambooHr from '@/views/Admin/BambooHr.vue';
import TeamOverviewColiquio from '@/views/TeamOverview/Coliquio/TeamOverviewColiquio.vue';
import AbsenceTypes from '@/views/AbsenceType/AbsenceTypes.vue';
import AbsenceTypeEdit from '@/views/AbsenceType/AbsenceTypeEdit.vue';
import TemporaryPassword from '@/views/Temporary/Password.vue';
import TeamOverviewTimeAccount from '@/views/TeamOverview/TeamOverviewTimeAccount.vue';
import FixedPriceProjectReports from '@/views/Report/FixedPriceProjectReports.vue';
import UpcomingPayments from '@/views/Admin/UpcomingPayments.vue';
import TeamOverviewPauseRules from '@/views/TeamOverview/TeamOverviewPauseRules.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'TimeEntries',
    component: TimeEntries,
    children: [
      {
        path: '/entry/:id',
        name: 'TimeEntryEdit',
        component: TimeEntryEdit,
        meta: { activeGroup: 'timeentries' },
      },
      {
        path: '/entry/add/:entryDate',
        name: 'TimeEntryAdd',
        component: TimeEntryEdit,
        meta: { activeGroup: 'timeentries' },
      },
      {
        path: '/entry/addfromstopwatch',
        name: 'TimeEntryAddFromStopwatch',
        component: TimeEntryEdit,
        meta: { activeGroup: 'timeentries' },
      },
      {
        path: '/entry/add/user/:appUserId/:entryDate',
        name: 'TimeEntryAddForUser',
        component: TimeEntryEdit,
        meta: { activeGroup: 'timeentries' },
      },
      {
        path: '/pause/:id',
        name: 'PauseEdit',
        component: PauseEdit,
        meta: { activeGroup: 'timeentries' },
      },
      {
        path: '/pause/add/:entryDate',
        name: 'PauseAdd',
        component: PauseEdit,
        meta: { activeGroup: 'timeentries' },
      },
      {
        path: '/stopwatchedit',
        name: 'StopwatchOldLayoutEdit',
        component: StopwatchOldLayoutEdit,
        meta: { activeGroup: 'timeentries' },
      },
    ],
  },
  {
    path: '/home',
    name: 'Home',
    component: TimeEntries,
  },
  {
    path: '/networkerror',
    name: 'NetworkError',
    component: NetworkError,
    meta: { layout: 'unauthorized', anonymous: true },
  },
  {
    path: '/notfound',
    name: 'NotFound',
    component: NotFound,
    meta: { layout: 'unauthorized', anonymous: true },
  },
  {
    path: '/login/:fromhp?',
    name: 'Login',
    component: Login,
    meta: { layout: 'auth', anonymous: true },
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { layout: 'auth', anonymous: true },
  },
  {
    path: '/transfer/:guid',
    name: 'TransferAccount',
    component: TransferAccount,
    meta: { layout: 'auth', anonymous: true },
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { layout: 'auth', anonymous: true },
  },
  {
    path: '/resetpassword/:id',
    name: 'ResetPassword',
    component: () => import('../views/Auth/ResetPassword.vue'),
    meta: { layout: 'auth', anonymous: true },
  },
  {
    path: '/absencetypes',
    name: 'AbsenceTypes',
    component: AbsenceTypes,
    meta: { activeGroup: 'absencetypes' },
    children: [
      {
        path: '/absencetypes/:id',
        name: 'AbsenceTypeEdit',
        component: AbsenceTypeEdit,
        meta: { activeGroup: 'absencetypes' },
      },
    ],
  },
  {
    path: '/absenceteam',
    name: 'AbsenceTeam',
    component: AbsenceTeam,
    meta: { activeGroup: 'absence' },
    children: [
      {
        path: '/absenceteam/edit/:id',
        name: 'AbsenceTeamEdit',
        component: AbsenceEdit,
        meta: { activeGroup: 'absence', backRouteName: 'AbsenceTeam' },
      },
    ],
  },
  {
    path: '/ownabsences',
    name: 'Ownabsences',
    component: OwnAbsences,
    meta: { activeGroup: 'absence' },
    children: [
      {
        path: '/ownabsences/:id',
        name: 'OwnabsencesEdit',
        component: AbsenceEdit,
        meta: { activeGroup: 'absence', backRouteName: 'Ownabsences' },
      },
      {
        path: '/teamabsencefromcalendaredit/:id',
        name: 'TeamAbsencesFromCalenderEdit',
        component: AbsenceEdit,
        meta: { activeGroup: 'absence', backRouteName: 'Ownabsences' },
      },
    ],
  },
  {
    path: '/timeaccount',
    name: 'TimeAccount',
    component: TimeAccount,
    meta: { activeGroup: 'timeentries' },
    children: [
      {
        path: '/timeaccount/adjustments/:id',
        name: 'TimeAdjustmentEdit',
        component: TimeAdjustmentEdit,
        meta: { activeGroup: 'timeentries' },
      },
    ],
  },
  {
    path: '/teamoverview',
    name: 'TeamOverview',
    component: TeamOverview,
    meta: { activeGroup: 'timeentries' },
  },
  {
    path: '/teamoverview-coliquio',
    name: 'TeamOverviewColiquio',
    component: TeamOverviewColiquio,
    meta: { activeGroup: 'timeentries' },
  },
  {
    path: '/team-timeaccount',
    name: 'TeamOverviewTimeAccount',
    component: TeamOverviewTimeAccount,
    meta: { activeGroup: 'timeentries' },
  },
  {
    path: '/timeapproval',
    name: 'TimeApproval',
    component: TeamOverviewApproval,
    meta: { activeGroup: 'timeentries' },
  },
  {
    path: '/pauserules',
    name: 'PauseRules',
    component: TeamOverviewPauseRules,
    meta: { activeGroup: 'timeentries' },
  },
  {
    path: '/pw',
    name: 'PW',
    component: TemporaryPassword,
    meta: { activeGroup: 'timeentries' },
  },
  {
    path: '/list',
    name: 'List',
    component: List,
    meta: { activeGroup: 'postprocess' },
    children: [
      {
        path: '/list/entry/:id',
        name: 'ListTimeEntryEdit',
        component: TimeEntryEdit,
        meta: { activeGroup: 'postprocess' },
      },
    ],
  },
  {
    path: '/listexport/:guid',
    name: 'ListExport',
    component: ListExport,
    meta: { layout: 'export' },
  },
  {
    path: '/external/:guid',
    name: 'ListExternal',
    component: ListExternal,
    meta: { layout: 'shared' },
  },
  {
    path: '/shared/:guid',
    name: 'ListExternalExternal',
    component: () => import('../views/List/ListExternalExternal.vue'),
    meta: { layout: 'shared', anonymous: true },
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('../views/Report/Reports.vue'),
    meta: { activeGroup: 'postprocess' },
  },
  {
    path: '/billabletargetreport',
    name: 'BillableTargetReport',
    component: () => import('../views/Report/BillableTargetReport.vue'),
    meta: { activeGroup: 'postprocess' },
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects,
    meta: { activeGroup: 'masterdata' },
    children: [
      {
        path: '/projects/customer/:id',
        name: 'EditCustomer',
        component: EditCustomer,
        meta: { activeGroup: 'masterdata' },
      },
      {
        path: '/projects/customer/:id/:readonly',
        name: 'ViewCustomer',
        component: EditCustomer,
        meta: { activeGroup: 'masterdata' },
      },
      {
        path: '/projects/customer/:customerid/:projectid',
        name: 'EditProject',
        component: EditProject,
        meta: { activeGroup: 'masterdata' },
      },
      {
        path: '/projects/customer/:customerid/:projectid/:readonly',
        name: 'ViewProject',
        component: EditProject,
        meta: { activeGroup: 'masterdata' },
      },
    ],
  },
  {
    path: '/projects/report/:projectid',
    name: 'ProjectReport',
    component: ProjectReport,
    meta: { activeGroup: 'masterdata' },
  },
  {
    path: '/projecttasks',
    name: 'ProjectTasks',
    component: ProjectTasks,
    meta: { activeGroup: 'projecttasks' },
    children: [
      {
        path: '/projecttasks/:id',
        name: 'ProjectTaskEdit',
        component: ProjectTaskEdit,
        meta: { activeGroup: 'projecttasks' },
      },
    ],
  },
  {
    path: '/raterules',
    name: 'RateRules',
    component: RateRules,
    meta: { activeGroup: 'masterdata' },
  },
  {
    path: '/tags',
    name: 'Tags',
    component: Tags,
    meta: { activeGroup: 'tags' },
    children: [
      {
        path: '/tags/:id',
        name: 'EditTag',
        component: TagEdit,
        meta: { activeGroup: 'tags' },
      },
    ],
  },
  {
    path: '/user',
    name: 'User',
    component: User,
    meta: { activeGroup: 'masterdata' },
    children: [
      {
        path: '/user/:id',
        name: 'EditUser',
        component: EditUser,
        meta: { activeGroup: 'masterdata' },
      },
    ],
  },
  {
    path: '/timeentryextrafieldmetadata',
    name: 'TimeEntryExtraFields',
    component: TimeEntryExtraFieldMetadata,
    meta: { activeGroup: 'masterdata' },
    children: [
      {
        path: '/timeentryextrafieldmetadata/:id',
        name: 'TimeEntryExtraFieldsEdit',
        component: TimeEntryExtraFieldMetadataEdit,
        meta: { activeGroup: 'masterdata' },
      },
    ],
  },
  {
    path: '/publicholidaygroup',
    name: 'PublicHolidayGroup',
    component: PublicHolidayGroup,
    meta: { activeGroup: 'masterdata' },
  },
  {
    path: '/publicholidaygroup/:id',
    name: 'PublicHolidayGroupEdit',
    component: PublicHolidayGroupEdit,
    meta: { activeGroup: 'masterdata' },
    children: [
      {
        path: '/publicholidaygroup/:id',
        name: 'PublicHolidayGroupEditSlideOut',
        component: PublicHolidayGroupEditSlideOut,
        meta: { activeGroup: 'masterdata' },
      },
      {
        path: '/publicholidaygroup/:groupId/editholiday/:id',
        name: 'PublicHolidayEdit',
        component: PublicHolidayEdit,
        meta: { activeGroup: 'masterdata' },
      },
      {
        path: '/publicholidaygroup/:groupId/addholiday/:date',
        name: 'PublicHolidayAdd',
        component: PublicHolidayEdit,
        meta: { activeGroup: 'masterdata' },
      },
    ],
  },
  {
    path: '/outgoinginvoice',
    name: 'OutgoingInvoice',
    component: OutgoingInvoiceList,
    meta: { activeGroup: 'postprocess' },
  },
  {
    path: '/outgoinginvoice/:year/:month',
    name: 'OutgoingInvoice',
    component: OutgoingInvoiceList,
    meta: { activeGroup: 'postprocess' },
  },
  {
    path: '/outgoinginvoiceedit/:year/:month/:id',
    name: 'OutgoingInvoiceEdit',
    component: OutgoingInvoiceEdit,
    meta: { activeGroup: 'postprocess' },
    children: [
      {
        path: '/outgoinginvoiceedit/:year/:month/:id/:customerId',
        name: 'EditCustomerInvoice',
        component: EditCustomer,
        meta: { activeGroup: 'postprocess' },
      },
      {
        path: '/outgoinginvoiceedit/:year/:month/:id/settings/edit',
        name: 'EditOutInvAccountSettings',
        component: OutInvAccountSettings,
        meta: { activeGroup: 'postprocess' },
      },
    ],
  },
  {
    path: '/outgoinginvoiceexport/:id',
    name: 'OutgoingInvoiceExport',
    component: OutgoingInvoiceExport,
    meta: { layout: 'export' },
  },
  {
    path: '/settingsaccount',
    name: 'AccountSettings',
    component: AccountSettings,
  },
  {
    path: '/settingsaccount/advcontract',
    name: 'AdvContract',
    component: AdvContract,
    meta: { layout: 'unauthorized' },
  },
  {
    path: '/migration',
    name: 'Migration',
    component: St2Migration,
  },
  {
    path: '/settingsuser',
    name: 'UserSettings',
    component: UserSettings,
  },
  {
    path: '/logs',
    name: 'Logs',
    component: Logs,
    meta: { layout: 'administrator' },
  },
  {
    path: '/admin/queries',
    name: 'AdminQueries',
    component: AdminQueries,
    meta: { layout: 'administrator' },
  },
  {
    path: '/admin/regenerateinvoice',
    name: 'RegenerateInvoice',
    component: RegenerateInvoice,
    meta: { layout: 'administrator' },
  },
  {
    path: '/admin/unpaidinvoices',
    name: 'UnpaidInvoices',
    component: UnpaidInvoices,
    meta: { layout: 'administrator' },
  },
  {
    path: '/admin/lug',
    name: 'LuG',
    component: LeuteUndGeld,
    meta: { layout: 'administrator' },
  },
  {
    path: '/admin/upcoming',
    name: 'UpcomingPayments',
    component: UpcomingPayments,
    meta: { layout: 'administrator' },
  },
  {
    path: '/admin/bamboohr',
    name: 'BambooHr',
    component: BambooHr,
    meta: { layout: 'administrator' },
  },
  {
    path: '/payment',
    name: 'Payment',
    component: () => import('../views/Payment/Payment.vue'),
    meta: { activeGroup: 'payment' },
    children: [
      {
        path: '/payment/invoicedata',
        name: 'EditAccountInvoiceData',
        component: () => import('../views/Payment/EditAccountInvoiceData.vue'),
        meta: { activeGroup: 'payment' },
      },
      {
        path: '/payment/paymentdata',
        name: 'EditPaymentData',
        component: () => import('../views/Payment/EditPaymentData.vue'),
        meta: { activeGroup: 'payment' },
      },
      {
        path: '/payment/licensedata',
        name: 'EditLicenseData',
        component: () => import('../views/Payment/EditLicenseData.vue'),
        meta: { activeGroup: 'payment' },
      },
    ],
  },
  {
    path: '/paymentsetup',
    name: 'PaymentSetup',
    component: () => import('../views/Payment/PaymentSetup.vue'),
    meta: { activeGroup: 'payment' },
    children: [
      {
        path: '/paymentsetup/invoicedata',
        name: 'EditAccountInvoiceData',
        component: () => import('../views/Payment/EditAccountInvoiceData.vue'),
        meta: { activeGroup: 'payment' },
      },
      {
        path: '/paymentsetup/paymentdata',
        name: 'EditPaymentData',
        component: () => import('../views/Payment/EditPaymentData.vue'),
        meta: { activeGroup: 'payment' },
      },
      {
        path: '/paymentsetup/licensedata',
        name: 'EditLicenseData',
        component: () => import('../views/Payment/EditLicenseData.vue'),
        meta: { activeGroup: 'payment' },
      },
    ],
  },
  {
    path: '/payment/invoice/:id',
    name: 'InvoiceExport',
    component: InvoiceExport,
    meta: { activeGroup: 'payment', layout: 'export', anonymous: true },
  },
  {
    path: '/paymentdone',
    name: 'PaymentDone',
    component: () => import('../views/Payment/PaymentDone.vue'),
  },
  {
    path: '/usersetuperror',
    name: 'UserSetupError',
    component: UserSetupError,
    meta: { layout: 'unauthorized', anonymous: true },
  },
  {
    path: '/onboardingroute',
    name: 'OnBoardingRoute',
    component: OnBoardingRoute,
  },
  {
    path: '/test',
    name: 'Test',
    component: Test,
  },
  {
    path: '/fixedpriceprojectreports',
    name: 'FixedPriceProjectReports',
    component: FixedPriceProjectReports,
  },
  {
    path: '*',
    component: () => import('@/views/NotFound.vue'),
    meta: { layout: 'unauthorized', anonymous: true },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to: any, from: any, next: any) => {
  if (!to.matched.some((record: any) => record.meta.anonymous)) {
    try {
      if (!UserStore.dataLoaded) {
        await UserStore.reloadStore();
      }

      if (UserStore.userSettings.setupErrors?.length && to.path != '/projects' && to.name != 'EditCustomer' && to.name != 'EditProject') {
        if (UserStore.userSettings.CanEditCustomersAndProjects) {
          next({
            path: '/projects',
          });
        } else {
          next({
            path: '/usersetuperror',
          });
        }
      } else {
        await reloadGlobalData();

        if (!UserStore.userSettings.onboardingCompleted && to.name != 'OnBoardingRoute') {
          next({ name: 'OnBoardingRoute' });
        }
      }

      next();
    } catch (err) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath },
      });
    }
  } else {
    next();
  }
});

export default router;
